import { GetterTree } from 'vuex'
import { ManagementServicesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<ManagementServicesState, RootState> = {
    managementServices:state => state.managementServices,
};
